import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import styles from './Chats.module.scss';
import FaqRedirectionPage from './FaqRedirectionPage';
import { clickTracker, linksObj } from '../../lib/common';

const CreatedTicketPage = ({ loading, ticketCreateResp, pageType, selectedIssueVal }) => {
  const navigate = useNavigate();
  const storageTicketResp = JSON.parse(sessionStorage.getItem('ticketResp'));
  const ticketId = ticketCreateResp?.ticketId || storageTicketResp?.ticketId;
  const agentName = ticketCreateResp?.agentName || storageTicketResp?.agentName;
  const hasFaqPage = Object.keys(linksObj).includes(selectedIssueVal);
  return (
    <>
      <div className={`${styles.ExecutiveBox} mb-20`}>
        <div className={`${styles.TextBox}`}>
          <div className={`${styles.ExecutiveIcon} csicon`} />
          <div className={`${styles.ChatText} font14 fw500 color111`}>
            {pageType === 'final'
              ? 'Thank you for submitting your query in detail.'
              : 'Thank you for confirming your issue. We have registered it with us.'}
          </div>
        </div>
      </div>
      {loading ? (
        <div className={`${styles.TicketBox} mb-20`}>
          <div>
            <div className="bt-spinner" style={{ height: '25px', width: '25px' }} />
          </div>
        </div>
      ) : (
        <div className={`${styles.TicketBox} mb-20`}>
          <div className={`${styles.TicketTimer} csicon`} />
          <div className={`${styles.TicketId} mt-15`}>
            <div className="font14 fw400 color111">Ticket Id : &nbsp;</div>
            <div className="font14 fw600 color007"> {ticketId || ''}</div>
          </div>
          <div className={`${styles.TicketTxt} font13 fw400 color111 mt-4`}>
            Our support executive <span className="fw500">{agentName || ''}</span> will reach out to you in{' '}
            <span className="fw500">24-72 hours!</span>
          </div>
          <button
            onClick={async () => {
              await clickTracker('View_ticket', 'Raiseaticket');
              navigate('/csportal/myTickets');
            }}
            type="button"
            className={`${styles.TicketButton} mt-10`}
          >
            <div className="font13 fw600 color111 mr-10">View My Tickets</div>
            <div className={`${styles.LinkIcon} csicon`} />
          </button>
        </div>
      )}

      {pageType === 'final' && selectedIssueVal !== 'Others' && hasFaqPage && (
        <FaqRedirectionPage selectedIssueVal={selectedIssueVal} />
      )}
    </>
  );
};

export default CreatedTicketPage;

CreatedTicketPage.propTypes = {
  ticketCreateResp: PropTypes.object,
  pageType: PropTypes.string,
  selectedIssueVal: PropTypes.string,
  loading: PropTypes.bool,
};
